import { Button, Modal } from "antd";
import { roleNames } from "../../constant";

const Success = ({
  open,
  handleCancel,
  handleBack,
  mode = null,
  role = null,
}) => {
  const isLogin = mode === "login";

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={
        !isLogin && (
          <div
            style={{
              display: "flex",
              gap: "8px",
              padding: "10px",
            }}
          >
            <Button
              onClick={() => handleBack("back")}
              style={{
                flex: 1,
                background: "#F5F5F5",
                color: "#6B6B6B",
                border: "1px solid #EDEDED",
                paddingTop: "24px",
                paddingBottom: "24px",
                fontSize: "18px",
                borderRadius: "8px",
              }}
            >
              Add Another QA
            </Button>
            <Button
              onClick={handleBack}
              style={{
                flex: 1,
                background: "#052659",
                color: "#FFFFFF",
                border: "none",
                paddingTop: "24px",
                paddingBottom: "24px",
                fontSize: "18px",
                borderRadius: "8px",
              }}
            >
              Go to Assigned Calls
            </Button>
          </div>
        )
      }
      width={700}
      closable={true}
      title={
        <div className="d-flex flex-column align-items-center text-center">
          <div className="d-flex justify-content-center w-100 mb-2">
            <img src={"../../../assets/assign.png"} alt="Success icon" />
          </div>
          <div className="mt-2 px-4 text-start">
            <h3 className="success-model-heading-css">
              {isLogin
                ? role == roleNames.qa
                  ? "Welcome, QA Analyst!"
                  : "Welcome, Super Admin!"
                : "Calls Assigned Successfully"}
            </h3>
            <p className="my-3 success-model-css">
              {isLogin
                ? role == roleNames.qa
                  ? "You're all set to evaluate calls and contribute to quality improvement--let's get started"
                  : `You’ve successfully logged in to the QA Assignment dashboard.\nManage users, assign calls, and track QA performance seamlessly.`
                : `The call recording for Rajesh Mehta (Call ID: CRD-20349) has\nbeen successfully assigned to Kunal Sinha under the\nTransactional.`}
            </p>
          </div>
        </div>
      }
    />
  );
};

export default Success;
